import { useContext } from 'react';

import { JobPositionIdContext, JobPositionIdContextType } from '../contexts/job-position-id.context';

export const useJobPositionIdContext = (jobPositionId?: string): JobPositionIdContextType => {
  const context = useContext(JobPositionIdContext);
  return jobPositionId ?? context;
};
